var dragContext = (function () {
    function dragContext(A, y, x, w, v, u, r, s, o, n, g) {
        this.source = A || "grid";
        this.target = y || "grid";
        this.mode = x || "move";
        this.dropmode = w || "child";
        this.sid = v || 0;
        this.tid = u;
        this.sobj = r || null;
        this.tobj = s || null;
        this.sExtra = o || null;
        this.tExtra = n || null;
        this.before = g || false;
    }
    dragContext.prototype.valid = function () {
        if (this.sobj != this.tobj) {
            return true;
        }
        if (this.sid == this.tid) {
            return false;
        }
        if (this.target == "treeGrid") {
            var a = this.tid;
            while ((a = this.tobj.getParentId(a))) {
                if (this.sid == a) {
                    return false;
                }
            }
        }
        return true;
    };
    dragContext.prototype.close = function () {
        this.sobj = null;
        this.tobj = null;
    };
    dragContext.prototype.copy = function () {
        return new dragContext(this.source, this.target, this.mode, this.dropmode, this.sid, this.tid, this.sobj, this.tobj, this.sExtra, this.tExtra, this.before);
    };
    dragContext.prototype.set = function (e, c) {

        this[e] = c;
        return this;
    };
    dragContext.prototype.uid = function (e, c) {
        this.nid = this.sid;
        while (this.tobj.rowsAr[this.nid]) {
            this.nid = this.nid + new Date().valueOf();
        }
        return this;
    };
    dragContext.prototype.data = function () {
        if (this.sobj == this.tobj) {
            return this.sobj._getRowArray(this.sobj.rowsAr[this.sid]);
        }
        if (this.source == "tree") {
            return this.tobj.treeToGridElement(this.sobj, this.sid, this.tid);
        }
        else {
            return this.tobj.gridToGrid(this.sid, this.sobj, this.tobj);
        }
    };
    dragContext.prototype.attrs = function () {
        if (this.source == "tree") {
            return {};
        }
        else {
            return this.sobj.rowsAr[this.sid]._attrs;
        }
    };
    dragContext.prototype.childs = function () {
        if (this.source == "treeGrid") {
            return this.sobj._h2.get[this.sid]._xml_await
                ? this.sobj._h2.get[this.sid].has_kids
                : null;
        }
        return null;
    };
    dragContext.prototype.pid = function () {
        if (!this.tid) {
            return 0;
        }
        if (!this.tobj._h2) {
            return 0;
        }
        if (this.target == "treeGrid") {
            if (this.dropmode == "child") {
                return this.tid;
            }
            else {
                var c = this.tobj.rowsAr[this.tid];
                var a = this.tobj._h2.get[c.idd].parent.id;
                if (this.alfa && this.tobj._sbmod && c.nextSibling) {
                    var e = this.tobj._h2.get[c.nextSibling.idd].parent.id;
                    if (e == this.tid) {
                        return this.tid;
                    }
                    if (e != a) {
                        return e;
                    }
                }
                return a;
            }
        }
    };
    dragContext.prototype.ind = function () {
        if (this.tid == window.unknown) {
            return this.tobj.rowsBuffer.length;
        }
        if (this.target == "treeGrid") {
            if (this.dropmode == "child") {
                this.tobj.openItem(this.tid);
            }
            else {
                this.tobj.openItem(this.tobj.getParentId(this.tid));
            }
        }
        var a = this.tobj.rowsBuffer._dhx_find(this.tobj.rowsAr[this.tid]);
        if (this.alfa && this.tobj._sbmod && this.dropmode == "sibling") {
            var c = this.tobj.rowsAr[this.tid];
            if (c.nextSibling &&
                this._h2.get[c.nextSibling.idd].parent.id == this.tid) {
                return a + 1;
            }
        }
        return (a +
            1 +
            (this.target == "treeGrid" &&
                a >= 0 &&
                this.tobj._h2.get[this.tobj.rowsBuffer[a].idd].state == "minus"
                ? this.tobj._getOpenLenght(this.tobj.rowsBuffer[a].idd, 0)
                : 0));
    };
    dragContext.prototype.img = function () {
        if (this.target != "grid" && this.sobj._h2) {
            return this.sobj.getItemImage(this.sid);
        }
        else {
            return null;
        }
    };
    dragContext.prototype.slist = function () {
        var c = new Array();
        for (var a = 0; a < this.sid.length; a++) {
            c[c.length] = this.sid[a][this.source == "tree" ? "id" : "idd"];
        }
        return c.join(",");
    };
    return dragContext;
})();

export default dragContext;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dragContext.js